import styled from "styled-components";

export const StyledLogin = styled.div`
  width: 100%;
  max-width: 500px;
  min-height: 100vh;
  margin: 0 auto;
  background: #f5f5f5;
  color: #1f2933;

  ul,
  ol {
    padding-left: 24px;
  }

  #customerIdentifier {
    padding: 10px 4px 10px 0;
  }

  .cover-section {
    position: relative;
    width: 100%;
    height: 35vh;
    min-height: 280px;
    overflow: hidden;
  }

  .cover-section .lazy-load-image-background,
  .cover-section .lazy-load-image-loaded,
  .cover-section img {
    width: 100%;
    height: 100%;
    display: block;
  }

  .cover-section img {
    object-fit: cover;
  }

  .login-section {
    position: relative;
    width: 100%;
    min-height: 65vh;
    margin: 0 auto;
    padding: 30px;
    background: #fff;
    box-shadow: 0 -2px 15px rgba(0, 0, 0, 0.18);
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }

  .login-section footer {
    margin-top: auto;
  }

  .login-section .brand-logo {
    display: block;
    width: auto;
    max-width: 100px;
    max-height: 60px;
    margin: 0 auto;
  }

  @media (max-width: 768px) {
    .cover-section img {
      object-fit: contain;
    }

    .login-section .brand-logo {
      width: 80%;
      max-width: 220px;
      height: auto;
      max-height: none;
      object-fit: contain;
    }
  }

  .return-to-store-link {
    width: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    color: #3b444d;
    font-size: 14px;
    font-weight: 700;
    text-decoration: none;
    border-radius: ${(props) => (props.rounded ? "10px" : "0")};
    padding: 10px 12px;
  }

  .return-to-store-link:hover .return-to-store-text {
    text-decoration: underline;
    text-underline-offset: 2px;
  }

  .return-to-store-arrow {
    font-size: 14px;
  }

  .return-title {
    width: 100%;
    max-width: 450px;
    margin: 30px 0 20px;
    color: var(--rms-v2-text-title);
    font-size: 18px;
    font-weight: 700;
  }

  .input-label {
    margin: 10px 0 0;
    color: #3b444d;
    font-size: 14px;
  }

  .brand-note {
    width: 100%;
    max-width: 450px;
    margin-top: 30px;
    font-size: 12px;
  }

  .otp-input {
    width: 40px;
    height: 40px;
    margin-left: 10px;
    font-size: 1rem;
    text-align: center;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type="number"] {
    -moz-appearance: textfield;
  }

  .otp-input:focus {
    border-bottom: ${(props) =>
      props.themeColor
        ? `2px solid ${props.themeColor}`
        : "2px solid rgba(217, 217, 217, 1)"} !important;
  }

`;

export const StyledDrawerTnC = styled.div`
  width: 100%;
  box-sizing: border-box;
  max-height: min(82vh, 720px);
  padding: 22px 20px 24px;
  background: var(--rms-v2-surface, #fff);
  color: var(--rms-v2-text-body);
  font-size: 12px;
  overflow: visible;
  position: relative;

  ul,
  ol {
    padding-left: 20px;
  }

  .terms-drawer-close {
    background: #fff;
    top: -50px;
    z-index: 5;
  }

  > div:first-of-type p {
    color: var(--rms-v2-text-title);
    margin: 0;
  }
`;
